export default __webpack_public_path__ + "static/media/nepal2.95cd86cd.jpg";